import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';
import { Type } from 'class-transformer';
import { Utils } from 'cc-common';

export class WorkflowQueueResultDto {
    managementCompanyName: string;
    workflowId: number;
    communityId: number;
    community: string;
    location: string;
    status: string;
    description: string;

    @Type(() => Date)
    dueDate: Date; // Date only property

    @Type(() => Date)
    createdOn: Date; // NOTE: Inlcudes time component. Will have to convert from UTC to user preferred timezone

    handling: string;
    hasNotes: boolean; // NOTE: Indicates is work flow has notes

    @Type(() => UserNameDisplayResultDto)
    dashboardResponsibleUsers: Array<UserNameDisplayResultDto>; // 	Note: This list has to be displayed as comma separate values in the UI. For now use DisplayName property in the UI

    allowProcessing: boolean; // NOTE: Indicates if user is allowed to process work flow
    allowAttributeCommunity: boolean;

    @Type(() => UserNameDisplayResultDto)
    addedBy: UserNameDisplayResultDto;
    addedByCam: boolean;

    @Type(() => Date)
    invoiceDate: Date;

    get responsibleUsers(): string {
        return !!this.dashboardResponsibleUsers
            ? this.dashboardResponsibleUsers.map((r) => r.displayName).join(', ')
            : '';
    }

    get addedByUserDisplayText(): string {
        return Utils.notNullAndDefined(this.addedBy) ? this.addedBy.displayName : null;
    }
}
